import dayjs from "@eisox/dayjs";
import { z } from "@eisox/zod";

import { DATE_FORMAT } from "~/constants/date.constant";
import { m } from "~/paraglide/messages";

export const periodSchema = z
  .object({
    begin: z.string().refine(value => dayjs(value, DATE_FORMAT).isValid(), {
      error: m.invalid_date_format(),
    }),
    end: z.string().refine(value => dayjs(value, DATE_FORMAT).isValid(), {
      error: m.invalid_date_format(),
    }),
  })
  .refine(
    value => {
      const { begin, end } = value;
      return begin === end || dayjs(begin, DATE_FORMAT).isBefore(dayjs(end, DATE_FORMAT));
    },
    {
      error: m.start_after_end(),
    },
  );

export const periodsSchema = z.array(
  z
    .object({
      added: z.boolean(),
      removed: z.boolean(),
    })
    .and(periodSchema),
);

export type PeriodType = z.infer<typeof periodSchema>;
export type PeriodsType = z.infer<typeof periodsSchema>;
